import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    competency:[]
}

export const fetchCompetency = createAsyncThunk('competency/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/competency`)
    return response.data
  })


let userSlice = createSlice({
  name:'competency',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchCompetency.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchCompetency.fulfilled,(state,action)=>{
          state.isLoading = false
          state.competency = action.payload
      })
      .addCase(fetchCompetency.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;